/**
 * Controller-UI-Status
 *
 * Open/Close vom GameControllerSession-Popup. An App-Level mounted, damit
 * eine bestehende Mobile-Pairing-Session über Projektwechsel hinweg
 * weiterläuft, ohne dass der User erneut QR scannen muss.
 */

import { create } from 'zustand'

interface ControllerStore {
  open: boolean
  setOpen: (next: boolean | ((prev: boolean) => boolean)) => void
}

export const useControllerStore = create<ControllerStore>((set) => ({
  open: false,
  setOpen: (next) =>
    set((s) => ({
      open: typeof next === 'function' ? (next as (prev: boolean) => boolean)(s.open) : next,
    })),
}))
